module.exports = __webpack_public_path__ + "static/media/track-raining-blood.3913e98f.png";